import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  getExGrupos,
  getMasGrupos,
  setBusquedaGrupo,
  unsetExGrupoSeleccionado,
} from '../../../actions/extrusion/ExGrupos'
import {
  getMasPerfiles,
  getPerfiles,
  setBusquedaPerfil,
  unsetPerfilSeleccionado,
} from '../../../actions/extrusion/ExPerfiles'
import {
  getExSeries,
  getMasSeries,
  setBusquedaSerie,
  unsetExSerieSeleccionada,
} from '../../../actions/extrusion/ExSeries'
import {
  getExSubSeries,
  getMasSubSeries,
  setBusquedaSubSerie,
  unsetExSubSerieSeleccionada,
} from '../../../actions/extrusion/ExSubSeries'
import { unsetListasTratamientos } from '../../../actions/extrusion/ExTratamientos'
import {
  setBusquedaExtrusion,
  unsetBusquedaExtrusion,
} from '../../../actions/extrusion/buscadorExtrusion'

const BuscadorExtrusion = () => {
  const dispatch = useDispatch()

  const [valor, setValor] = useState('')
  const [busquedaRealizada, setBusquedaRealizada] = useState('')
  const [grupoSeleccionado, setGrupoSeleccionado] = useState('')
  const [serieSeleccionada, setSerieSeleccionada] = useState('')
  const [subserieSeleccionada, setSubserieSeleccionada] = useState('')
  const [perfilSeleccionado, setPerfilSeleccionado] = useState('')

  const portal = useSelector(state => state.portal.portal)
  const lista_tratamientos_disponibles = useSelector(
    state => state.extratamientos.lista_tratamientos_disponibles,
  )
  const exGrupos = useSelector(state => state.exgrupos)
  const exSeries = useSelector(state => state.exseries)
  const exSubseries = useSelector(state => state.exsubseries)
  const exPerfiles = useSelector(state => state.experfiles)

  const onChange = e => {
    setValor(e.target.value)
  }

  const limpiarSeleccion = () => {
    dispatch(unsetExGrupoSeleccionado())
    dispatch(unsetExSerieSeleccionada())
    dispatch(unsetExSubSerieSeleccionada())
    dispatch(unsetPerfilSeleccionado())
  }

  const realizarBusqueda = data => {
    setValor('')
    setBusquedaRealizada(data)
    setGrupoSeleccionado('')
    setSerieSeleccionada('')
    setSubserieSeleccionada('')
    setPerfilSeleccionado('')
  }

  const onSubmit = e => {
    e.preventDefault()
    if (valor) {
      if (lista_tratamientos_disponibles && lista_tratamientos_disponibles.length > 0) {
        dispatch(unsetListasTratamientos())
      }

      limpiarSeleccion()

      if (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') {
        dispatch(setBusquedaExtrusion(valor))
        dispatch(setBusquedaGrupo(valor))
        dispatch(getExGrupos(valor))
        dispatch(setBusquedaSerie(valor))
        dispatch(getExSeries(grupoSeleccionado, valor))

        if (portal.ex_agrupacion_perfiles === 'GSBP') {
          dispatch(setBusquedaSubSerie(valor))
          dispatch(getExSubSeries(grupoSeleccionado, serieSeleccionada, valor))
        }

        dispatch(setBusquedaPerfil(valor))
        dispatch(getPerfiles(grupoSeleccionado, serieSeleccionada, subserieSeleccionada, valor))

        realizarBusqueda(valor)
      } else if (portal.ex_agrupacion_perfiles === 'SP') {
        dispatch(setBusquedaExtrusion(valor))
        dispatch(setBusquedaSerie(valor))
        dispatch(getExSeries(null, valor))
        dispatch(setBusquedaPerfil(valor))
        dispatch(getPerfiles(null, null, null, valor))

        realizarBusqueda(valor)
      } else {
        dispatch(setBusquedaExtrusion(valor))
        dispatch(setBusquedaPerfil(valor))
        dispatch(getPerfiles(null, null, null, valor, 'S'))

        realizarBusqueda(valor)
      }
    }
  }

  const onClick = e => {
    e.preventDefault()
    eliminarFiltro(e)
  }

  const eliminarFiltro = e => {
    e.preventDefault()
    setBusquedaRealizada('')

    if (lista_tratamientos_disponibles && lista_tratamientos_disponibles.length > 0) {
      dispatch(unsetListasTratamientos)
    }

    if (e.currentTarget.dataset.tipo === 'busqueda') {
      if (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') {
        dispatch(unsetExGrupoSeleccionado())
        dispatch(unsetExSerieSeleccionada())
        dispatch(unsetExSubSerieSeleccionada())
        dispatch(unsetPerfilSeleccionado())
        dispatch(getMasGrupos())
        dispatch(unsetBusquedaExtrusion())
      } else if (portal.ex_agrupacion_perfiles === 'SP') {
        dispatch(unsetExSerieSeleccionada())
        dispatch(unsetExSubSerieSeleccionada())
        dispatch(unsetPerfilSeleccionado())
        dispatch(unsetBusquedaExtrusion())
        dispatch(getMasSeries())
      } else if (portal.ex_agrupacion_perfiles === 'P') {
        dispatch(unsetPerfilSeleccionado())
        dispatch(unsetBusquedaExtrusion())
        dispatch(getMasPerfiles())
      }
    } else if (e.currentTarget.dataset.tipo === 'grupo') {
      dispatch(unsetExGrupoSeleccionado())
      dispatch(unsetExSerieSeleccionada())
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(getMasGrupos())
      dispatch(unsetBusquedaExtrusion())
    } else if (e.currentTarget.dataset.tipo === 'serie') {
      if (portal.ex_agrupacion_perfiles === 'SP') {
        dispatch(unsetExGrupoSeleccionado)
      }
      dispatch(unsetExSerieSeleccionada())
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(unsetBusquedaExtrusion())
      dispatch(getMasSeries('', exGrupos.grupo_seleccionado))
    } else if (e.currentTarget.dataset.tipo === 'subserie') {
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(getMasSubSeries('', exGrupos.grupo_seleccionado, exSeries.serie_seleccionada))
    } else if (e.currentTarget.dataset.tipo === 'perfil') {
      dispatch(unsetPerfilSeleccionado())
      dispatch(
        getMasPerfiles(
          '',
          exGrupos.grupo_seleccionado,
          exSeries.serie_seleccionada,
          exSubseries.subserie_seleccionada,
        ),
      )
    }
  }

  const filtro_busqueda = (
    <Fragment>
      {!busquedaRealizada ? (
        ''
      ) : (
        <li className='active'>
          <a
            href='/#'
            className='filtro-aplicado'
            data-tipo='busqueda'
            onClick={onClick}>
            {busquedaRealizada}
          </a>
        </li>
      )}
    </Fragment>
  )

  const filtro_grupo = (
    <Fragment>
      {!exGrupos.grupo_seleccionado ||
      portal.ex_agrupacion_perfiles === 'SP' ||
      portal.ex_agrupacion_perfiles === 'P' ? (
        ''
      ) : (
        <li className='active'>
          <a
            href='/#'
            className='filtro-aplicado'
            data-tipo='grupo'
            onClick={onClick}>
            {exGrupos.grupo_seleccionado}
          </a>
        </li>
      )}
    </Fragment>
  )

  const filtro_serie = (
    <Fragment>
      {!exSeries.serie_seleccionada || portal.ex_agrupacion_perfiles === 'P' ? (
        ''
      ) : (
        <li className='active'>
          <a
            href='/#'
            className='filtro-aplicado'
            data-tipo='serie'
            onClick={onClick}>
            {exSeries.serie_seleccionada}
          </a>
        </li>
      )}
    </Fragment>
  )

  const filtro_subserie = (
    <Fragment>
      {!exSubseries.subserie_seleccionada || portal.ex_agrupacion_perfiles !== 'GSBP' ? (
        ''
      ) : (
        <li className='active'>
          <a
            href='/#'
            className='filtro-aplicado'
            data-tipo='subserie'
            onClick={onClick}>
            {exSubseries.subserie_seleccionada}
          </a>
        </li>
      )}
    </Fragment>
  )

  const filtro_perfil = (
    <Fragment>
      {!exPerfiles.perfil_seleccionado ? (
        ''
      ) : (
        <li className='active'>
          <a
            href='/#'
            className='filtro-aplicado'
            data-tipo='perfil'
            onClick={onClick}>
            {exPerfiles.perfil_seleccionado}
          </a>
        </li>
      )}
    </Fragment>
  )

  return (
    <div className='row buscador-extrusion'>
      <div className='col-md-12'>
        <form
          onSubmit={onSubmit}
          className='form-inline form-default justify-content-end pr-3 pl-3'>
          <div className='input-group'>
            <input
              className='form-control'
              type='text'
              name='valor'
              placeholder='Búsqueda de grupo, serie, subserie o código de perfil'
              onChange={onChange}
              value={valor}
            />
            <div className='input-group-append'>
              <button
                type='submit'
                className='btn btn-primary'>
                <FontAwesomeIcon
                  icon={faSearch}
                  className='mr-2'
                />{' '}
                Buscar
              </button>
            </div>
            {!exGrupos.grupo_seleccionado &&
            !exSeries.serie_seleccionada &&
            !exSubseries.subserie_seleccionada &&
            busquedaRealizada !== '' ? (
              <div className='filtros-menu-extrusion'>
                <ul className='tt-filter-list filtros-activos'>{filtro_busqueda}</ul>
              </div>
            ) : (
              <div className='filtros-menu-extrusion'>
                <ul className='tt-filter-list filtros-activos'>
                  {filtro_grupo}
                  {filtro_serie}
                  {filtro_subserie}
                  {filtro_perfil}
                </ul>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}

export default BuscadorExtrusion
